import { Collapse, Container, Typography } from '@mui/material';
import React from 'react';
import Link from 'next/link';
import CustomAccordion from '../../shared/CustomAccordion.styled';
import SubDropdownMobile from './SubDropdownMobile';
import styles from '../styles';

const DropdownMobile = ({ nav, expand, leftNav, handleExpand }) => (
  <Container sx={{ p: 0 }}>
    <Collapse in={expand}>
      {expand &&
        nav?.map(link => (
          <CustomAccordion
            styles={styles.collapseContainer}
            title={link.title}
            description={
              <SubDropdownMobile
                nav={link}
                handleExpand={handleExpand}
                ariaLabel={link.Link.ariaLabel}
              />
            }
          />
        ))}
      {expand &&
        leftNav?.Link?.map((child, i) => (
          <Link
            key={i}
            underline='none'
            href={child?.link}
            passHref
            legacyBehavior
            onClick={handleExpand}
          >
            <Typography variant='h5' sx={styles.subNavLinks}>
              {' '}
              {child?.title}
            </Typography>
          </Link>
        ))}
      {/* {expand &&
        rightNav.children.map((child, i) => (
          <Link key={i} underline='none' href={child.link.link} passHref>
            <Typography component='p' variant='h6' sx={styles.subNavLinks}>
              {' '}
              {child.link.title}
            </Typography>
          </Link>
        ))} */}
    </Collapse>
  </Container>
);

export default DropdownMobile;
